import { useState } from "react";
import PlayIcon from "../VideoPlayer/assets/play.svg";
import { VideoPlayerModal } from "../VideoPlayerModal";

interface VideoPreviewProps {
  src: string;
  className?: string;
  width?: number;
  height?: number;
  description?: React.ReactNode;
}

export function VideoPreview(props: VideoPreviewProps) {
  const { src, className = "", width, height, description } = props;
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      {/* 视频缩略图 */}
      <div
        className={`relative cursor-pointer ${className}`}
        onClick={() => setModalOpen(true)}
        style={{ width, height }}
      >
        <video
          className="w-full h-full object-cover"
          src={src}
          muted
          preload="metadata"
        />
        {/* 播放按钮覆盖层 */}
        <div className="absolute inset-0 flex items-center justify-center rounded-lg">
          <div className="flex w-[32px] h-[32px] justify-center items-center rounded-full bg-black/8 backdrop-blur-sm">
            <PlayIcon className="w-[16px] h-[16px]" />
          </div>
        </div>
      </div>

      {/* 预览弹窗 - 复用现有的 VideoPlayerModal */}
      <VideoPlayerModal
        src={src}
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        prompt={description ? String(description) : undefined}
        showCloseButton={true}
        autoPlay={true}
      />
    </>
  );
}
